import React from "react";
import "../styles/Main.css";

export default function Main(props) {
  return (
    <div className="Main">
      <div className="section">
        <div className="row">
          <div className="image">
            <img src={props.data.img} alt="" id="icon" />
          </div>
          <div className="info">
            <h1 className="temperature-main">
              <span className="temperature-current">
                {props.data.temperature}
              </span>
              <span className="temperature-c">°C</span>
            </h1>

            <h3 className="weather-info_city">
              <span className="city-name">{props.data.cityname} </span>
              <span className="h-1 weather-info_country">
                {props.data.country}
              </span>
            </h3>
            <div className="weather-info_update">Last updated:</div>
            <div className="weather-info_date">{props.date}</div>
            <div className="weather-info_time">{props.time}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
